import { Box, Table, TableContainer } from "@mui/material";
import { ContentKey } from "../../../../features/talentProfile/TalentDetails";
import AddButton from "../addButton/AddButton";
import FormTableBody from "./FormTableBody";
import FormTableHeaders from "./FormTableHeaders";

type DataItemValues = {
  [key: string]: string | any;
};

export type DataItem = {
  values: DataItemValues;
  id: string;
  deletable?: boolean;
  toggleable?: boolean;
  disabled?: boolean;
  linkTo?: string;
};

export type FormTableHeader = {
  text: string;
  tooltip?: string;
};

export type EmptyStateText = {
  show: boolean;
  text?: string;
};

type Props = {
  headers?: FormTableHeader[];
  disableEditRow?: boolean;
  disableEditOnly?: boolean;
  data: DataItem[];
  translationKeys?: string[];
  addButtonLabel?: string | null;
  contentKey?: string;
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  handleDelete?: (id: string) => void;
  handleToggle?: (id: string) => void;
  valueMaxLines?: number;
  columnWidths?: string[];
  stripedTable?: boolean;
  addButtonVariant?: "outlined" | "contained" | "text";
  emptyStateText?: EmptyStateText;
};

const FormTable = ({
  headers,
  data,
  disableEditRow = false,
  disableEditOnly = false,
  translationKeys,
  handleOpenEditModal,
  handleDelete,
  handleToggle,
  addButtonLabel,
  contentKey,
  valueMaxLines,
  columnWidths,
  stripedTable,
  addButtonVariant = "outlined",
  emptyStateText,
}: Props) => {
  return (
    <>
      <TableContainer>
        <Table>
          {!!headers && (
            <FormTableHeaders
              headers={headers}
              disableEditRow={disableEditRow}
              disableDeleteRow={!handleDelete}
            />
          )}
          <FormTableBody
            data={data}
            translationKeys={translationKeys}
            valueMaxLines={valueMaxLines}
            columnWidths={columnWidths}
            disableEditRow={disableEditRow}
            disableEditOnly={disableEditOnly}
            handleOpenEditModal={handleOpenEditModal}
            handleDelete={handleDelete}
            handleToggle={handleToggle}
            contentKey={contentKey}
            stripedTable={stripedTable}
            emptyStateText={emptyStateText}
          />
        </Table>
      </TableContainer>
      <Box sx={{ marginTop: "0.5rem" }}>
        {!disableEditRow && addButtonLabel && (
          <AddButton
            label={addButtonLabel}
            onClick={() =>
              handleOpenEditModal(`${contentKey}_add` as ContentKey)
            }
            variant={addButtonVariant}
          />
        )}
      </Box>
    </>
  );
};

export default FormTable;
